import { Transition } from "@headlessui/react"

const LargeSkeleton = () => (
    <Transition
        show={true}
        enter="transition ease-in-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition ease-in-out duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
    >
        <div className="animate-pulse">
            <div className="skeleton-animation h-48 rounded-10"></div>
            <div className="py-8 px-7 flex flex-col gap-7">
                <div className="skeleton-animation h-7 w-3/4"></div>
                <div className="skeleton-animation h-7 w-5/6"></div>
                <div className="skeleton-animation h-7 w-3/4"></div>
                <div className="skeleton-animation h-7 w-2/3"></div>
                <div className="skeleton-animation h-7 w-5/6"></div>
                <div className="skeleton-animation h-7 w-1/2"></div>
            </div>
        </div>
    </Transition>
)

export default LargeSkeleton